module.exports = __webpack_public_path__ + "static/img/coins.3ab507ca.png";